module.exports = __webpack_public_path__ + "img/banner3.3f14104f.png";